import {IconButton, Stack, styled, Typography} from '@mui/material';

const StyledDialogHeader = styled(Stack)`
	flex-direction: row-reverse;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
	background-color: ${({theme}) => theme.palette.primary.main};
	padding: 16px;
	${({theme}) => theme.breakpoints.up('sm')} {
		flex-direction: row;
	}
	${({theme}) => theme.breakpoints.up('md')} {
		padding: 16px 24px;
	}
`;

const StyledDialogTitle = styled(Typography)`
	flex: 1;
	color: ${({theme}) => theme.palette.common.white};
	font-weight: 600;
	font-size: 1.25rem;
`;

const StyledCloseButton = styled(IconButton)`
	color: ${({theme}) => theme.palette.common.white};
`;

export {StyledCloseButton, StyledDialogHeader, StyledDialogTitle};
